import IBaseStepModel from "./interfaces/BaseStepModel.interface";

export interface ICustomizeStep extends IBaseStepModel {

    giftCardUrl: string;
    mediaUrl:string;
    personalMessage: string;

    userGiftCards: Array<string>;
    userMedias: Array<string>;


//    isDirty: boolean;
//    isValid(): boolean;
}

export class CustomizeStepModel implements ICustomizeStep {

    giftCardUrl: string;
    mediaUrl:string;
    personalMessage: string;

    userGiftCards: Array<string>;
    userMedias: Array<string>;

    isDirty: boolean;

    static validateModel(model: ICustomizeStep): boolean {
        if (!model) return false;

        //if (model.giftCardUrl?.trim()
        //    && (model.personalMessage?.trim())) {

        //    return true;
        //}

        if (model.giftCardUrl?.trim()) {
            return true;
        }

        return false;
    }

    //isValid(): boolean {
    //    return CustomizeStepModel.validateModel(this);
    //    ////this.mediaUrl?.trim()
    //    //if (this.giftCardUrl?.trim()
    //    //    && (this.personalMessage?.trim())) {

    //    //    return true;
    //    //}

    //    //return false;
    //}
}